import { render, staticRenderFns } from "./receivingInformation.vue?vue&type=template&id=5c3329fc&scoped=true&"
import script from "./receivingInformation.vue?vue&type=script&lang=js&"
export * from "./receivingInformation.vue?vue&type=script&lang=js&"
import style0 from "./receivingInformation.vue?vue&type=style&index=0&id=5c3329fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3329fc",
  null
  
)

export default component.exports